import { createAsyncThunk } from "@reduxjs/toolkit";
import { clientV3, chatClient, getError } from "../../../utils/axiosClient";

export const getThreads = createAsyncThunk(
  "conversations/getThreads",
  async (
    {
      tenantId,
      userId,
    }: { tenantId: string | number; userId: string | number },
    { rejectWithValue }
  ) => {
    try {
      const response = await clientV3.get(
        `/v3/chat/get-threads-testing?tenantId=${tenantId}&userId=${userId}`
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(getError(err));
    }
  }
);

export const muteThread = async (payload: any) => {
  try {
    const response = await clientV3.post("/chat/toggle-thread-mute", payload);
    return response.data;
  } catch (error) {
    return getError(error);
  }
};

export const getThreadMediaAPI = async (threadId: string | number) => {
  try {
    const response = await clientV3.get(`/chat/thread/${threadId}/media`);
    return response.data;
  } catch (error) {
    return getError(error);
  }
};

export const getThreadChat = createAsyncThunk(
  "conversations/getThreadChat",
  async (
    {
      chatId,
      lastMessage,
    }: { chatId: string | number; lastMessage: string | number },
    { rejectWithValue }
  ) => {
    try {
      const response = await clientV3.get(
        `/chat/get-chat-messages?chatId=${chatId}&lastMessage=${lastMessage}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      // return error;
    }
  }
);

export const deleteMessage = async (payload: {
  chatId: string | number;
  messageId: string;
}) => {
  try {
    const response = await chatClient.post(
      "/conversation/delete-message",
      payload
    );
    return response.data;
  } catch (error) {
    return getError(error);
  }
};

export const getThreadUsers = createAsyncThunk(
  "conversations/getThreadUsers",
  async ({ chatId }: { chatId: string | number }, { rejectWithValue }) => {
    try {
      const response = await clientV3.get(
        `/v3/chat/get-chat-users?chatId=${chatId}`
      );
      // console.log(response.data, "CHAT USERS");
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      // return error;
    }
  }
);

export const pinMessageAPI = createAsyncThunk(
  "conversations/pinMessage",
  async (
    payload: {
      threadId: string | number;
      messageId: string | null;
      duration: string | null;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await chatClient.post(
        "/conversation/pin-message",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
    }
  }
);

export const getPinnedMessageAPI = createAsyncThunk(
  "conversations/getPinnedMessage",
  async ({ threadId }: { threadId: string | number }, { rejectWithValue }) => {
    try {
      const response = await chatClient.get(
        `/conversation/pinned-message/${threadId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
    }
  }
);

export const editMessageAPI = async (payload) => {
  try {
    const response = await chatClient.put(
      "/conversation/edit-message-v3",
      payload
    );
    return response.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};

/* GROUP API */
export const createGroup = async (payload) => {
  // console.log(payload, "Payload");
  try {
    const response = await chatClient.post(
      "/conversation/create-group-v3",
      payload
    );
    return response.data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteGroup = async (payload: { groupId: string | number }) => {
  try {
    const response = await chatClient.post(
      "/conversation/delete-group-v3",
      payload
    );
    return response.data;
  } catch (error) {
    return getError(error);
  }
};

export const leaveGroup = async (payload) => {
  try {
    const response = await chatClient.post(
      "/conversation/leave-group-v3",
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const editGroup = async (payload: {
  groupId: string | number;
  name?: string;
  profilePicture?: string;
}) => {
  try {
    const response = await chatClient.post(
      "/conversation/auth/update-group-v3",
      payload
    );
    return response.data;
  } catch (e) {
    return getError(e);
  }
};

export const getCommonThreads = async (payload) => {
  try {
    const response = await clientV3.get(
      `/chat/get-common-groups?otherUserId=${+payload.otherUserId}`
    );
    return response.data.commonThreads;
  } catch (e) {
    console.log(e);
  }
};

export const sendMessageAPI = async (payload) => {
  try {
    const response = await chatClient.post(
      "/conversation/send-message",
      payload
    );
    console.log(response);
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const forwardMessageToUsers = createAsyncThunk(
  "conversations/forwardMessageToUsers",
  async ({ messages }: { messages: any }, { rejectWithValue }) => {
    try {
      const response = await chatClient.post(`/conversation/forward-message`, {
        messages,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      // return error;
    }
  }
);

export const reactToComment = createAsyncThunk(
  "conversations/reactToComment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await chatClient.post(
        `/conversation/add-reaction`,
        payload
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
      // return error;
    }
  }
);

export const addReaction = async (payload: {
  messageId: string;
  userId: string | number;
  emoji: string;
}) => {
  try {
    const response = await chatClient.post(
      "/conversation/add-reaction-v3",
      payload
    );
    return response.data;
  } catch (e) {
    return e;
  }
};

export const starMessageAPI = createAsyncThunk(
  "conversations/starMessageAPI",
  async (
    payload: {
      chatId: string | number;
      messageId: string;
      userId: string | number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await clientV3.post("/chat/star-messages", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
    }
  }
);

export const unStarMessageAPI = createAsyncThunk(
  "conversations/unStarMessageAPI",
  async (
    payload: {
      chatId: string | number;
      messageId: string;
      userId: string | number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await clientV3.post("/chat/unstar-message", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
    }
  }
);

export const getStarredMessagesAPI = createAsyncThunk(
  "conversations/getStarredMessagesAPI",
  async (
    payload: { chatId?: string | number; userId: string | number },
    { rejectWithValue }
  ) => {
    try {
      const qs = `userId=${payload.userId}${
        payload.chatId ? `&chatId=${payload.chatId}` : ""
      }`;
      const response = await clientV3.get(`/chat/get-starred-messages?${qs}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
    }
  }
);

export const updateMessagesReceivedAPI = async (payload: {
  chatId: string | number;
  userId: string | number;
  user: any;
  message?: any;
}) => {
  try {
    const response = await chatClient.post(
      "/conversation/received-message",
      payload
    );
    return response.data;
  } catch (e) {
    return getError(e);
  }
};

export const updateMessagesReadAPI = async (payload: {
  chatId: string | number;
  userId: string | number;
  user: any;
}) => {
  try {
    const response = await chatClient.post(
      "/conversation/read-messages",
      payload
    );
    return response.data;
  } catch (e) {
    return getError(e);
  }
};

export const getThreadsMembers = createAsyncThunk(
  "conversations/getThreadsMembers",
  async ({ threadId }: { threadId: string | number }, { rejectWithValue }) => {
    try {
      const response = await clientV3.get(
        `/chat/get-chat-users?chatId=${threadId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getError(error));
    }
  }
);
